export default function HeroSection() {
  return (
    <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#E67E50] to-[#F4E8D8]"></div>
      
      <div className="relative z-10 text-center px-6">
        <h1 className="text-6xl font-bold text-white mb-4">
          RETURN POLICY
        </h1>
        <p className="text-xl text-white/90">
          Transparent and customer-focused
        </p>
      </div>
    </section>
  );
}
